<div class="message">{{ message }}</div>
<div class="close-button theme-ex" tabindex="0" (click)="closeHelp()" (keydown)="closeHelp()"></div>
